export const ADD_MESSAGE = "ADD_MESSAGE";

export const ADD_SUCCESS_MESSAGE = "ADD_SUCCESS_MESSAGE";

export const ADD_ERROR_MESSAGE = "ADD_ERROR_MESSAGE";

export const ADD_WARNING_MESSAGE = "ADD_WARNING_MESSAGE";

export const CLEAR_MESSAGE = "CLEAR_MESSAGE";